import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useDispatch } from 'react-redux';
import { submitMockTest } from '../../../../actions/mock-test';
import { shuffleArr } from '../../../../helpers/utils';
import KatexViewer from '@/helpers/Katex';

//text match template
const TemplateMatchText = ({ question, scrollToQ, section, model }) => {
  const dispatch = useDispatch();
  const [arrValue, setArrValue] = useState([]);
  let items: Array<any>;
  var updateValue: any;
  updateValue = shuffleArr(question?.answer);

  useEffect(() => {
    setArrValue(shuffleArr(question?.answer));
  }, []);

  useEffect(() => {
    try {
      var elmnt = document.getElementById('q-' + scrollToQ);
      const y = elmnt.getBoundingClientRect().top + window.scrollY - 200;
      window.scroll({
        top: y,
        behavior: 'smooth',
      });
      elmnt.focus();
    } catch (err) {
      // console.log('doesnot exist');
    }
    //window.scroll(0,findPos(elmnt));
  }, [scrollToQ]);

  function handleOnDragEnd(result) {
    if (!result.destination) return;
    items = Array.from(arrValue);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    var finalValue: any = {};
    var findCurrentDroppedKey = question?.answer[result.destination.index].key;
    var findCurrentDroppedValue = question?.answer.find(
      (obj) => obj.id == result.draggableId
    ).value;
    finalValue = {
      key: findCurrentDroppedKey,
      value: findCurrentDroppedValue,
      section: section,
      model: model,
      question: question?.id,
      is_correct: true,
    };
    dispatch(submitMockTest(finalValue));
    setArrValue(items);
  }
  return (
    <div className="mock-test-question-wrapper">
      <div className="type_blank text-match-question">
        <div className="sl-item mt-3">
          <div className="question-title-group">
            <div className="number" id={`q-${question.q_no}`}>
              {question.q_no}
            </div>
          </div>
        </div>
        <div className="question-title">
          {question?.instruction ? (
            <div className="d-flex instruction-question">
              <div
                dangerouslySetInnerHTML={{ __html: question?.instruction }}
                className="px-2"
              />
            </div>
          ) : (
            ''
          )}
          <p>
            {question?.has_expression ? (
              <KatexViewer text={question?.title} />
            ) : (
              question.title
            )}
          </p>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-sm text-center">Term</div>
            <div className="col-sm text-center">Match</div>
          </div>
          <div className="row mt-3 mr-0 ml-0">
            <div className="col mr-0 pr-0 pl-0">
              {question?.answer?.map(({ id, key }) => {
                return (
                  <div className="card mt-2 bg-ranking-card" key={id}>
                    <div className="card-body">
                      <div className="empty-content"></div>
                      <span>
                        {question?.has_expression ? <KatexViewer text={key} /> : key}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="col ml-0">
              <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="uValue">
                  {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      {arrValue?.map(({ id, value }, index) => {
                        return (
                          <div style={{ cursor: 'pointer !important' }} key={id}>
                            <Draggable draggableId={id.toString()} index={index}>
                              {(provided) => (
                                <div
                                  className="card mt-2 draggable-card bg-ranking-card"
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <div className="card-body">
                                    <div className="puzzle-item"></div>
                                    <span>
                                      {question?.has_expression ? (
                                        <KatexViewer text={value} />
                                      ) : (
                                        value
                                      )}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          </div>
                        );
                      })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateMatchText;